import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {
  MRIReportDataItem,
  MRIReportRequest
} from '@features/transactions/external-accounts/mri/mri-bulk-download.model';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class MriBulkDownloadService {
  private _apiUrl = environment.apiTransactHost + '/admin/offering';
  private _reportEndpoint = '/external-software/mri/report';
  private _http = inject(HttpClient)

  constructor() {
  }


  loadReport(request: MRIReportRequest): Observable<MRIReportDataItem[]> {
    let requestParams = new HttpParams()
      .set('month', request.month)
      .set('year', request.year);

    if (request.parentCompanyNames.length >0){
      requestParams = requestParams.append('parentCompanyNames', request.parentCompanyNames.join(','));
    }
    return this._http.get<MRIReportDataItem[]>(`${this._apiUrl}${this._reportEndpoint}`, {params: requestParams});
  }
}
